export class SocialButton extends PIXI.Container {
    constructor(title: string, color: number) {
        super();

        const btnBack = new PIXI.Graphics();
        btnBack.beginFill(color, 1);
        btnBack.drawRoundedRect(0, 0, 300, 50, 10);
        this.addChild(btnBack);

        const btnText = new PIXI.Text(title, {
            fill: 0xffffff,
            fontSize: 30,
            fontWeight: 'bold'
        });
        btnText.x = btnBack.width / 2 - btnText.width / 2;
        btnText.y = btnText.height / 2 - btnText.height / 2 + 6;
        this.addChild(btnText);

        this.interactive = true;
        this.buttonMode = true;
    }
}